export const escapeRegexChars = (text: string) => {
  return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};

export const validEmailAddressRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const isValidEmailAddress = (email: string) => {
  return validEmailAddressRegex.test(email);
};

export const capitalizeWords = (text: string | undefined) => {
  if (!text) return '';
  return text.replace(/\b\w/g, (char) => char.toUpperCase());
};

/**
 * Converts underscore-separated status strings to title case
 * Example: "carrier_selection_failed" -> "Carrier Selection Failed"
 */
export const formatStatusToTitleCase = (status: string) => {
  return status
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export const isShipiumEmail = (email?: string) => {
  return email ? /@shipium\.com$/i.test(email) : false;
};
